import * as React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faBars } from '@fortawesome/free-solid-svg-icons';
import { observer } from 'mobx-react';
import { useSystem } from '../../../hooks/useSystem';
import { useLocation, useNavigate } from 'react-router-dom';
import { InboxIconWidget } from './InboxIconWidget';
import { MediaIconWidget } from '../../content/MediaIconWidget';
import { immediateAction } from '../../utils';
import { Routing } from '../../../pages/Routing';

const logo = require('../../../../media/logo.png');

export interface ProfileHeaderWidgetProps {
  showMenu: () => any;
  showProfile: () => any;
  className?: any;
}

export const ProfileHeaderWidget: React.FC<ProfileHeaderWidgetProps> = observer((props) => {
  const system = useSystem();
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <S.Container className={props.className}>
      {!location.state ? (
        <S.Button
          {...immediateAction(() => {
            props.showMenu();
          })}
        >
          <S.Icon icon={faBars}></S.Icon>
        </S.Button>
      ) : (
        <S.Button
          {...immediateAction(() => {
            navigate(-1);
          })}
        >
          <S.Icon icon={faAngleLeft}></S.Icon>
        </S.Button>
      )}
      <S.LogoContainer
        {...immediateAction(() => {
          navigate(Routing.HOME, { replace: true });
        })}
      >
        <S.Logo src={logo} />
      </S.LogoContainer>
      <S.Right>
        <S.Button
          {...immediateAction(() => {
            navigate(Routing.NOTIFICATIONS, { state: 'push' });
          })}
        >
          <InboxIconWidget />
        </S.Button>
        <S.Button
          {...immediateAction(() => {
            props.showProfile();
          })}
        >
          <S.ProfileIcon
            media={{
              image: system.user?.image,
              name: system.user?.data?.profile_name
            }}
          />
        </S.Button>
      </S.Right>
    </S.Container>
  );
});
namespace S {
  export const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;
    height: 50px;
    border-bottom: solid 1px ${(p) => p.theme.layout.border};
  `;

  export const ProfileIcon = styled(MediaIconWidget)`
    width: 40px;
    height: 40px;
  `;

  export const Right = styled.div`
    display: flex;
    align-items: center;
    column-gap: 2px;
  `;

  export const LogoContainer = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
  `;

  export const Logo = styled.img`
    height: 25px;
  `;

  export const Button = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 50px;
    pointer-events: all;
  `;

  export const Icon = styled(FontAwesomeIcon)`
    color: white;
    font-size: 25px;
    pointer-events: none;
  `;
}
